"use client";

import { ArrowRight, ChevronDown, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Standard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const showrooms = [{
    city: <><span className="!text-xl">NORTH AMERICA</span></>
  }, {
    city: <><span className="!text-xl">MEXICO</span></>
  }, {
    city: <><span className="!text-xl">GLOBAL</span></>
  }];
  return <section data-section-id="5164" id="the-gst-standard" className="relative bg-background text-foreground overflow-hidden min-h-[85vh] flex items-center dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723303/img/industrial_precision_converter.png)] animate-[kenburns_30s_ease-in-out_infinite_alternate]" style={{
        animation: "kenburns 30s ease-in-out infinite alternate"
      }} />
        {}
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse at center, hsla(262, 48%, 12%, 0.35) 0%, hsla(262, 48%, 12%, 0.75) 60%, hsla(262, 48%, 12%, 0.95) 100%)"
      }} />
      </div>

      <style>{`
        @keyframes kenburns {
          0% { transform: scale(1) translate(0, 0); }
          100% { transform: scale(1.08) translate(-1%, -1%); }
        }
      `}</style>

      {}
      <div className="hidden lg:flex absolute right-6 xl:right-10 top-1/2 -translate-y-1/2 z-20 items-center">
        <span className="font-mono text-[10px] tracking-[0.3em] text-indigo-300 whitespace-nowrap" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          GST_REF &middot; INDUSTRIAL EXCELLENCE
        </span>
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-6">
          <div ref={ref} data-index={0} className={`col-span-12 md:col-span-10 lg:col-span-7 lg:col-start-2 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-10">
              <span className="h-px w-8 bg-indigo-500" aria-hidden="true" />
              <span className="font-mono text-xs tracking-[0.3em] text-indigo-300 uppercase">
                Precision Converting Solutions
              </span>
            </div>

            {}
            <h1 className="font-default font-bold text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] tracking-tighter text-white">
              Precision Converting
              <br />
              <span className="text-indigo-300">for Industrial Excellence.</span>
            </h1>

            {}
            <p className="mt-10 max-w-[480px] text-base lg:text-lg leading-relaxed text-indigo-100 font-default">
              Delivering customized die-cutting, slitting, and laminating services for industrial adhesives, tapes, and films. Engineered for B2B manufacturers in electronics, automotive, and aerospace.
            </p>

            {}
            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
              <Button asChild size="lg" className="h-12 px-8 bg-indigo-600 text-white hover:bg-indigo-700 font-default text-xs tracking-[0.2em] uppercase">
                <Link to="/ContactPage">
                  Request a Quote
                  <ChevronDown className="ml-1 h-4 w-4" />
                </Link>
              </Button>

              <Button asChild variant="ghost" size="lg" className="h-12 px-6 text-white hover:bg-white/10 hover:text-white font-default text-xs tracking-[0.2em] uppercase border border-indigo-500/40">
                <Link to="/ProductsPage">
                  View Capabilities
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="h-px w-full bg-indigo-500/20" />
          <div className="py-6 flex flex-wrap items-center justify-center sm:justify-between gap-x-8 gap-y-3">
            {showrooms.map((s, i) => <div data-index={i} key={s.city} className="flex items-center gap-2">
                <MapPin className="h-3 w-3 text-indigo-400" />
                <span className="font-mono text-[10px] sm:text-xs tracking-[0.25em] text-indigo-200 uppercase">
                  {s.city}
                </span>
                {i < showrooms.length - 1 && <span className="hidden sm:inline ml-6 text-indigo-500/40 font-mono text-xs">
                    &middot;
                  </span>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}